interface ProductAttributeTagProps {
    iconUrl?: string
    label: string
}
export default function ProductAttributeTag({
    iconUrl,
    label
}: ProductAttributeTagProps) {
    return (
        <div className="flex h-24 w-fit items-center gap-x-4 bg-col-bg-calm px-8 pt-3">
            {iconUrl && (
                <div className="h-16 w-16">
                    <img
                        src={iconUrl || ""}
                        alt={label}
                        className="h-full w-full object-contain"
                    />
                </div>
            )}
            <span className="Trade_Gothic_Text_14_150_0_300">{label}</span>
        </div>
    )
}
